var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 655.359,
    height: 655.359,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 6.827 6.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0 { fill: none; }"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_486850792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_486850144",
    className: "fil0",
    d: "M0 0h6.827v6.827H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_486850552",
    className: "fil0",
    d: "M.853.853h5.12v5.12H.853z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_486849568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_486849592",
    d: "M3.467 3.063 5.554.92a.244.244 0 0 1 .35.341L3.808 3.413l-.341.35-2.088 2.144a.244.244 0 0 1-.35-.34l2.097-2.154.34-.35z",
    style: {
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_486850024",
    d: "m1.38.92 2.087 2.143.34.35 2.097 2.154a.244.244 0 0 1-.35.34L3.467 3.763l-.341-.35L1.029 1.26a.244.244 0 0 1 .35-.34z",
    style: {
      fill: "#C0C0C0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/SG.8c70adbf44c8c70ca00ea152527e1a91.svg";
export { ForwardRef as ReactComponent };